module.exports = __webpack_public_path__ + "static/media/scanner-beep.b281c27f.ogg";


//////////////////
// WEBPACK FOOTER
// ./src/audio/scanner-beep.ogg
// module id = 397
// module chunks = 0